export const DATA_QCD = 'data-qcd';
export const DATA_OB = 'data-ob';
export const DATA_TARGET = 'data-target';
export const getObsufcatdAttributes = ({
  qcd,
  ob,
  target,
}: {
  qcd?: string;
  ob?: string;
  target?: string;
}) => {
  return {
    [DATA_QCD]: qcd,
    [DATA_OB]: ob,
    [DATA_TARGET]: target,
  };
};
